import { ClipboardCheck } from "lucide-react";

import { MantenedorDeCatalogo } from "@/components/catalogo/MantenedorDeCatalogo";

/**
 * Mantenedor de ítems de revisión del informe (pantalla "Crear revisión de
 * informe" del prototipo).
 *
 * Cada ítem es un punto del checklist que el revisor tilda al visar el informe
 * final. Toda la mecánica vive en `MantenedorDeCatalogo`: acá solo van los
 * rótulos, que es lo único que distingue a este catálogo del de contextos.
 */
export function RevisionInformes() {
  return (
    <MantenedorDeCatalogo
      recurso="informe-revision-items"
      singular="ítem de revisión"
      plural="ítems de revisión"
      icono={ClipboardCheck}
      ejemplo="Revisión de deslindes"
      descripcion="Puntos que el revisor verifica antes de visar el informe final."
      ayuda={
        <>
          Este catálogo define el checklist de la revisión final: el revisor tilda cada
          punto antes de visar. El orden es el del checklist y cada ítem nuevo se agrega al
          final. Eliminar uno solo lo saca de la oferta: si vuelves a crearlo con el mismo
          nombre, reaparece en su posición original.
        </>
      }
      vacio={{
        titulo: "El checklist está vacío",
        descripcion:
          "Agrega el primer ítem con el formulario de arriba: sin checklist, la revisión final no tiene qué verificar.",
      }}
    />
  );
}
